import type { Products } from "../types"

export const products: Products = new Map([
  [
    "re7-labs-sonic",
    {
      name: "Re7 Labs Cluster",
      entity: "re7-labs",
      vaults: ["0xF3c631B979EB59d8333374baA7c58B5Aff5e24D2"],
      deprecatedVaults: [
        "0xEeb63D2d370C5318ef174D366A41507F9380f093",
        "0x8537a336fC74EA742527E8300175A7b07a108c9E",
        "0x4c0AF5d6Bcb10B3C05FB5F3a846999a3d87534C7",
        "0x2De851E60e428106fC98fE94017466F8D71793d1",
        "0x3D9e5462A940684073EED7e4a13d19AE0Dcd13bc",
        "0xeEb1DC1Ca7ffC5b54aD1cc4c1088Db4E5657Cb6c",
        "0x2ad7546A19eb5D5eDb37EC88A4775995078d1CAd",
      ],
    },
  ],
  [
    "mev-capital-sonic",
    {
      name: "MEV Capital Sonic Cluster",
      entity: "mev-capital",
      description:
        "The MEV Capital Sonic Cluster provides a set of liquid collateral markets with an optimized risk-adjusted return",
      vaults: [],
      deprecatedVaults: [
        "0xa5cd24d9792F4F131f5976Af935A505D19c8Db2b",
        "0x196F3C7443E940911EE2Bb88e019Fd71400349D9",
        "0x0806af1762Bdd85B167825ab1a64E31CF9497038",
        "0xB38D431e932fEa77d1dF0AE0dFE4400c97e597B8",
        "0x05d57366B862022F76Fe93316e81E9f24218bBfC",
        "0x1cDA7E7B2023C3f3c94Aa1999937358fA9D01Aab",
        "0x9144C0F0614dD0acE859C61CC37e5386d2Ada43A",
        "0xeeaaB5c863f4b1c5356aF138F384AdC25Cb70Da6",
        "0x6f2Ab32A6487A2996c74Ed2b173dFDF3d5EEDB58",
        "0xF6E2ddf7a149C171E591C8d58449e371E6dc7570",
        "0xFFFC9d22304CF49784e9B31dDBEB066344b2B856",
        "0xD506F1E4AdFCf1196B7C5D2EbF4e858E33d7A93E",
        "0xdBc46ff39Cae7f37c39363B0CA474497dAD1d3cf",
        "0x08f04A3db30B0cd7E42E61b4e412b1123C52e8a1",
        "0x7aD07B280A17Ac7af489E487eaAf004b69786a0A",
        "0x12ac805F4596C3E55bb100B4593A1B8025CD2056",
        "0xdEBdAB749330bb976fD10dc52f9A452aaF029028",
        "0xDE604f03E44247b31f71C4Fa055F9F3ea08D1271",
        "0x6e14A20334724a194D2f8B38162522CAD202b986",
        "0x6F11663766bB213003cD74EB09ff4c67145023c5",
        "0xC37fa1c70D77bdEd373C551a92bAbcee44a9d04E",
        "0x8D024593d781B1C86EcD5d0f899d10C5E9de7069",
        "0x2A377470DcF0e00F6DEd484DDf82df65F0Fb50af",
        "0xB6a53021E7A40ea20DF1e1991B0C89432073386E",
      ],
    },
  ],
  [
    "mev-capital-beets",
    {
      name: "MEV Capital Beets Cluster",
      entity: "mev-capital",
      description:
        "The MEV Capital Beets Cluster provides a set of liquid collateral markets with an optimized stS looping",
      vaults: [
        "0x90a804D316A06E00755444D56b9eF52e5C4F4D73",
        "0x6832F3090867449c058e1e3088E552E12AB18F9E",
        "0xb936137169D777fcB8B7Cf02329620B78FCcEC0A",
        "0xF71B17cCF362B6dcC1b6917A05820477cF7802A0",
      ],
    },
  ],
])
